export default __webpack_public_path__ + "static/media/exclamation-message.42671ebb.svg";